import chHansMsg from '@/utils/languages/zh-hans.json';
import chHantMsg from '@/utils/languages/zh-hant.json';
import enUSMsg from '@/utils/languages/en-us.json';
import jaMsg from '@/utils/languages/ja.json';
import koMsg from '@/utils/languages/ko.json';

import '@/assets/fonts/font.css';

export const LANGUAGE_LIST = [
  { name: 'English', language: 'en', message: enUSMsg },
  { name: '한국어', language: 'ko', message: koMsg },
  { name: '日本語', language: 'ja', message: jaMsg },
  { name: '简体中文', language: 'zh-hans', message: chHansMsg },
  { name: '繁體中文', language: 'zh-hant', message: chHantMsg },
];

export const SUPPORTED_LANGUAGE_LIST = ['en', 'ko', 'ja', 'zh-hans', 'zh-hant'];
